/** Resolved runtime config from import.meta.env, with safe dev defaults. */

export interface RuntimeConfig {
  apiBase: string;
  wsUrl: string;
  userToken: string;
  defaultRestaurantId: string;
  useMocks: boolean;
}

function read(name: keyof ImportMetaEnv, fallback: string): string {
  const v = import.meta.env[name];
  return typeof v === "string" && v.length > 0 ? v : fallback;
}

export const config: RuntimeConfig = {
  apiBase: read("VITE_API_BASE", "https://vision.orees.cloud/api/v1"),
  wsUrl: read("VITE_WS_URL", "wss://vision.orees.cloud/socket"),
  // In production the token comes from the Orees Cloud session, not env. Env is a dev convenience.
  userToken: read("VITE_USER_TOKEN", ""),
  defaultRestaurantId: read("VITE_RESTAURANT_ID", "demo-venue"),
  useMocks: read("VITE_USE_MOCKS", "") === "1",
};
